export default function AppSection() {
  return (
    <section id="app" className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1024px] mx-auto">
        <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950 text-center mb-3">
          随时随地吃瓜
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10 md:mb-12">
          把51吃瓜最新网址装进口袋
        </p>
        <div className="bg-gradient-to-br from-primary-500 to-primary-700 rounded-2xl p-8 md:p-12 flex flex-col lg:flex-row items-center gap-8 max-w-[900px] mx-auto">
          <div className="flex-1 text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-background-50/20 text-background-50 text-xs font-medium mb-4">
              <i className="ri-smartphone-line text-sm w-4 h-4 flex items-center justify-center"></i>
              <span className="whitespace-nowrap">移动端友好</span>
            </div>
            <h3 className="font-heading font-bold text-xl md:text-2xl text-background-50 mb-3">
              手机浏览器直达，无需下载
            </h3>
            <p className="text-sm text-background-50/80 leading-relaxed mb-6">
              51吃瓜最新网址完美适配移动端浏览器，在手机、平板等设备上均可流畅浏览。
              打开浏览器输入网址即可访问最新51吃瓜爆料与黑料内容，无需安装任何APP。
            </p>
            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-3">
              <span className="inline-flex items-center gap-2 px-4 py-2 bg-background-50 text-primary-600 font-medium text-sm rounded-lg whitespace-nowrap cursor-pointer">
                <i className="ri-bookmark-line text-base w-4 h-4 flex items-center justify-center"></i>
                加入书签
              </span>
              <span className="inline-flex items-center gap-2 px-4 py-2 border border-background-50/30 text-background-50 font-medium text-sm rounded-lg hover:bg-background-50/10 transition-colors whitespace-nowrap cursor-pointer">
                <i className="ri-share-forward-line text-base w-4 h-4 flex items-center justify-center"></i>
                分享给朋友
              </span>
            </div>
          </div>
          <div className="flex-shrink-0">
            <div className="w-40 h-64 md:w-48 md:h-72 bg-background-50 rounded-2xl border-4 border-background-50/30 flex items-center justify-center">
              <div className="text-center p-4">
                <span className="w-14 h-14 flex items-center justify-center mx-auto mb-3 rounded-2xl bg-primary-500 text-background-50 font-bold text-xl">
                  51
                </span>
                <p className="font-heading font-bold text-xs text-foreground-900 leading-tight">
                  51吃瓜
                </p>
                <p className="font-heading font-bold text-xs text-foreground-900 leading-tight">
                  最新网址
                </p>
                <p className="text-[10px] text-foreground-500 mt-2">吃瓜爆料第一站</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}